module.exports = __webpack_public_path__ + "static/media/programming-icon.1848f42a.svg";